import React, { memo } from 'react';
import { Icon } from '@core/js/components/common/Icon';
import { Button } from '@core/js/components/common/Button';
import { MONTHS, CREATE_PASSKEYS_BUTTON } from '@theme/js/components/main/NevisPasskeysSwiss/constants';
import { useFormatter } from '@core/js/hooks/useFormatter';
import style from './NevisPasskeysItems.scss';
import { NevisPassKeysDialogSection } from '../NevisPassKeysDialogSection/NevisPassKeysDialogSection';
import { INevisPassKeysItem } from '@theme/js/components/main/NevisPasskeysSwiss/types';

export const NevisPasskeysItems = memo(({
    tkPrefix,
    isDisabled,
    t,
    data,
    isMobile,
    createPassKey,
    fetchPortlet,
    portletType
} : INevisPassKeysItem) => {
    const formatter = useFormatter();
    return (
        <div className={style.passKeyContainer}>
            <div className={style.subtitle}>
                {t(`${tkPrefix}passkeys.${isMobile ? '' : 'desktop.'}subtitle`)}
            </div>
            {data?.fidoAuthenticators?.map((code, index) =>
                <div key={index} className={style.passkeyItemContainer}>
                    <div className={style.passKeyTextWrapper}>
                        <div className={style.passKeyIconContainer}>
                            <Icon className={style.itemIcon}/>
                        </div>
                        <div className={style.passKeyInfo}>
                            <div className={style.passKeyName}>{code?.name}</div>
                            <div className={style.passKeyData}>
                                {t(`${tkPrefix}passkeys.createdOn`)}&nbsp;
                                {t(MONTHS[Number(formatter.date(code?.enrolledAt, '%m')) - 1])}&nbsp;
                                {formatter.date(code?.enrolledAt, '%d, %Y')}
                            </div>
                        </div>
                    </div>
                    <NevisPassKeysDialogSection
                        data={data}
                        fetchPortlet={fetchPortlet}
                        portletType={portletType}
                        tkPrefix={tkPrefix}
                        index={index}
                        t={t}
                    />
                </div>)}
            {isMobile && <Button
                className={style.createPasskeyBtn}
                onClick={createPassKey}
                disabled={isDisabled}>
                {t(CREATE_PASSKEYS_BUTTON)}
            </Button>}
        </div>
    );
});
